import { useState, useLayoutEffect, useEffect } from 'react';
/**
 * To enable the read more/less provision for the texts and animate the collapsible behavior
 * by setting the maxHeight
 * @param {scrollableDomRef} The ref object of the html dom which needs to be  collapsible.
 */
export const useToggleContentScroll = (scrollableDomRef: React.RefObject<HTMLElement>) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [maxHeightReviewContent, setMaxHeightReviewContent] = useState(200);

    const useIsomorphicLayoutEffect = process.browser ? useLayoutEffect : useEffect;
    useIsomorphicLayoutEffect(() => {
        if (scrollableDomRef) {
            const maxHeightReviewContent =
                scrollableDomRef.current && scrollableDomRef.current.scrollHeight;
            maxHeightReviewContent && setMaxHeightReviewContent(maxHeightReviewContent);
        }
    }, [scrollableDomRef]);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };
    return {
        isCollapsed,
        toggleCollapse,
        maxHeightReviewContent,
    };
};
